import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FileInput from './FileInput';

function FileInputDemo() {

  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>File Input</h4>
            <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
              <FileInput placeholder={'filename.jpg'} label={'Sample label'} className="mw-100 mr-2" width="260px"/>
              <FileInput placeholder={'filename.jpg'} label={'Sample label'} disabled className="mw-100 mx-2" width="300px"/>
              <FileInput placeholder={'filename.jpg'} label={'Sample label'} isValid={true} className="mw-100 mx-2" width="300px"/>
              <FileInput placeholder={'filename.jpg'} label={'Sample label'} isInvalid={true} className="mw-100 ml-2" width="300px"/>
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default FileInputDemo;
